var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_card-pos",
    "data-name": "vuesax/linear/card-pos",
    transform: "translate(-428 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-pos",
    transform: "translate(428 508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,13.942,13.942,0",
    transform: "translate(4.585 4.584)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,1.4,1.4,0",
    transform: "translate(12.951 19.925)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,2.788,2.788,0",
    transform: "translate(16.092 15.399)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.868,9.61,9.615,1.864c2.473-2.473,3.71-2.485,6.16-.035L21.5,7.557c2.45,2.45,2.438,3.687-.035,6.16l-7.747,7.747c-2.473,2.473-3.71,2.485-6.16.035L1.833,15.77C-.617,13.32-.617,12.1,1.868,9.61Z",
    transform: "translate(2.333 2.335)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H23.333",
    transform: "translate(2.333 25.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentWhite);
export default __webpack_public_path__ + "static/media/paymentWhite.2a2c4d0568c6fb89a1538e63b261ffc8.svg";
export { ForwardRef as ReactComponent };